import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import DashboardTable from "../../../components/dashboard-layout/table/DashboardTable";
import { columnsProduct, ArchiveActionButton } from "../config/productTable";
import { fetchProducts } from "../../../services/products.service";
import Button from "../../../components/dashboard-layout/button/Button";
import { useDashboardModal } from "../../../components/dashboard-layout/modal/util";
import ProductForm from "./ProductForm";
import { Context } from "../../../Context";

export default function AllyProducts({ isProfile }) {
  const { currentUser } = useContext(Context);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });
  const [changeTable, setChangeTable] = useState(false);
  const [searchBarActiveVal, setSearchBarActiveVal] = useState("");
  const params = useParams();
  const modal = useDashboardModal();
  const onGetProducts = async () => {
    setLoading(true);
    try {
      const { data } = await fetchProducts({
        partnerId: !isProfile ? parseInt(params.id) : undefined,
      });
      const dataOrdered = data.sort((elm) =>
        elm.status !== "DISABLED" ? -1 : 1
      );
      const formattedRows = dataOrdered.map((row) => {
        const formatData = {
          id: row?.id,
          name: row?.name,
          type: row?.type || "-",
          unitName:
            row?.commissionType === "PERCENT_PER_TOTAL"
              ? "Porcentaje"
              : "Pesos",
          commission:
            row?.commissionType === "PERCENT_PER_TOTAL"
              ? `${row?.commissionValue}%`
              : `$ ${new Intl.NumberFormat("de-DE").format(
                  row?.commissionValue
                )}`,
          branchId: params.id,
          action: (
            <ArchiveActionButton
              productId={row?.id}
              setChangeTable={setChangeTable}
            />
          ),
          status: row?.status,
        };
        setPagination({ ...pagination });
        return formatData;
      });
      setProducts(formattedRows);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const onChangeSearchBar = (e) => {
    setSearchBarActiveVal(e.target.value);
  };
  const handleProductCreation = () => {
    modal.handleCancel();
    onGetProducts();
  };
  useEffect(() => {
    const timeout = setTimeout(() => onGetProducts(), 400);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchBarActiveVal]);
  useEffect(() => {
    if (changeTable) {
      onGetProducts();
      setChangeTable(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeTable]);
  return (
    <>
      <DashboardTable
        columns={columnsProduct}
        tableTitle="Productos"
        data={products}
        pagination={pagination}
        page={pagination.page}
        rowKey="key"
        loading={loading}
        searchBarPlaceholder="Buscar productos"
        onChangeSearchBar={onChangeSearchBar}
        rowClassName={(record, index) => {
          return record.status === "DISABLED" ? "row-transparent" : "";
        }}
        customButton={
          currentUser.type === "SUPER_ADMIN" ? (
            <Button type="primary" actionButton={modal.showModal}>
              {"+ Crear producto"}
            </Button>
          ) : null
        }
      />
      <ProductForm
        modalSetting={modal}
        handleAfterProductCreation={handleProductCreation}
      />
    </>
  );
}
